import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { LeadGroup } from "../v1/LeadGroup";
import {
  MrfiktivCreateLeadGroupDtoGen,
  MrfiktivLeadGroupControllerGetParamsGen,
  MrfiktivUpdateLeadGroupDtoGen
} from "../v1/data-contracts";

class LeadGroupService {
  mrfiktivProxy: LeadGroup;

  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new LeadGroup(mrfiktivHttpClientProvider.client());
  }

  async create(partnerId: string, data: MrfiktivCreateLeadGroupDtoGen) {
    const leadGroup = (await this.mrfiktivProxy.leadGroupControllerCreate(partnerId, data)).data;
    return leadGroup;
  }

  async get(data: MrfiktivLeadGroupControllerGetParamsGen) {
    const leadGroups = (await this.mrfiktivProxy.leadGroupControllerGet(data)).data;
    return leadGroups;
  }

  async getOne(partnerId: string, leadGroupId: string) {
    const leadGroup = (await this.mrfiktivProxy.leadGroupControllerGetOne(partnerId, leadGroupId)).data;
    return leadGroup;
  }

  async update(partnerId: string, leadGroupId: string, data: MrfiktivUpdateLeadGroupDtoGen) {
    const leadGroup = (await this.mrfiktivProxy.leadGroupControllerUpdate(partnerId, leadGroupId, data)).data;
    return leadGroup;
  }

  async delete(partnerId: string, leadGroupId: string) {
    const leadGroup = (await this.mrfiktivProxy.leadGroupControllerDelete(partnerId, leadGroupId)).data;
    return leadGroup;
  }
}

export default new LeadGroupService(new MrfiktivHttpClientProvider());
